import { EyeOutlined, HourglassOutlined, PhoneOutlined, SwapOutlined, VideoCameraOutlined, WhatsAppOutlined } from "@ant-design/icons";

import { EChannel } from "./EChannel";

export const renderChannelOption = (
  channel: EChannel
): React.ReactNode => {
  // Keep domain enums UI-agnostic; render icons at presentation layer only.
  switch (channel) {
    case EChannel.whatsapp:
      return (
        <WhatsAppOutlined style={{ color: '#25D366' }} />
      );
    case EChannel.sms:
      return (
        <PhoneOutlined />
      );
    case EChannel.redirecting:
      return (
        <SwapOutlined />
      );
    case EChannel.showcase:
      return (
        <EyeOutlined />
      );
    case EChannel.stamp:
      return (
        <HourglassOutlined />
      );
    case EChannel.demo:
      return (
        <VideoCameraOutlined />
      );
  }
};